import Questionnaire from './Container';

export default Questionnaire;
